import React, { ReactElement } from 'react';

interface Props extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
    children?: any;
}

export default function AppAtag({ children, ...prop }: Props): ReactElement {
    return <a {...prop}>{children}</a>;
}
